import React from 'react'
import styles from './styles.module.scss'

export interface Props {
  errors: Errors[]
  isError: boolean
}

export interface Errors {
  item: string
  message: string
}

const ErrorList = ({ errors, isError }: Props) => {
  return (
    <>
      {errors.length > 0 && isError && (
        <div className={styles.root}>
            <span className={styles.message}>
              入力内容に誤りがあります。下記項目をご確認下さい。
            </span>
            <ul>
              {errors.map(({ message }, index) => (
                <li key={index}>
                  ・{message}
                </li>
              ))}
            </ul>
        </div>
      )}
    </>
  )
}

export default ErrorList
